export const onlyLotteryDigits = (value) => String(value || "").replace(/\D/g, "");

export const parseLotteryScanCode = (value) => {
  const raw = onlyLotteryDigits(value);
  const gameNo = raw.slice(0, 3);
  const hasGameSeparator = raw[3] === "0";
  const bookStart = hasGameSeparator ? 4 : 3;
  const bookNo = raw.slice(bookStart, bookStart + 6);
  const afterBookIndex = bookStart + 6;
  const ticketCandidate = raw.slice(afterBookIndex, afterBookIndex + 3);
  const isTicketScan = ticketCandidate.length === 3 && !["000", "999"].includes(ticketCandidate);

  return {
    raw,
    gameNo,
    bookNo,
    ticketNo: isTicketScan ? ticketCandidate : "",
    ticketCandidate,
    scanType: isTicketScan ? "ticket" : "book",
    isComplete: gameNo.length === 3 && bookNo.length === 6,
  };
};

export default parseLotteryScanCode;
